import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'attach-file',
  templateUrl: './attach-file.component.html',
  styleUrls: ['./attach-file.component.scss'],
})
export class AttachFileComponent implements OnInit {
  public overField: boolean = false;
  public showFileLoad: any;
  public errorMessage: string = '';
  public hasError: boolean = false;

  @Input() formatString: string;
  @Output() fileToUpload = new EventEmitter<File>();
  @Output() errorFile = new EventEmitter<string>();
  @Input() colContainer: string = "col-6";
  @Input() limiteMB: number = 3; // Default 3MB
  @Input() maxSizeBytes: number = 3 * 1024 * 1024; // 3MB en bytes
  @Input() required: boolean = false; // Indica si el archivo es requerido

  constructor() { }

  ngOnInit(): void {
    // Si se especifica limiteMB, convertir a bytes
    if (this.limiteMB) {
      this.maxSizeBytes = this.limiteMB * 1024 * 1024;
    }
  }

  public showFile(event: File): void {
    // Reset error state
    this.hasError = false;
    this.errorMessage = '';

    // Validar si hay archivo
    if (!event) {
      return;
    }

    // Validar tamaño del archivo
    if (event.size > this.maxSizeBytes) {
      this.hasError = true;
      this.errorMessage = `El archivo excede el tamaño máximo permitido de ${this.limiteMB}MB. Tamaño actual: ${this.formatFileSize(event.size)}`;
      this.showFileLoad = null;
      this.errorFile.emit(this.errorMessage);
      return;
    }

    // Validar tipo de archivo si se especifica
    if (this.formatString && !this.isValidFileType(event)) {
      this.hasError = true;
      this.errorMessage = `Tipo de archivo no permitido. Formatos aceptados: ${this.formatString}`;
      this.showFileLoad = null;
      this.errorFile.emit(this.errorMessage);
      return;
    }

    // Si pasa todas las validaciones
    this.showFileLoad = [event];
    this.fileToUpload.emit(event);
  }

  private isValidFileType(file: File): boolean {
    if (!this.formatString) return true;

    const acceptedTypes = this.formatString.split(',').map(type => type.trim());
    const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
    const mimeType = file.type;

    return acceptedTypes.some(type => {
      if (type.startsWith('.')) {
        return type.toLowerCase() === fileExtension;
      } else {
        return mimeType.includes(type.replace('*', ''));
      }
    });
  }

  private _formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Método público para usar en el template
  public formatFileSize(bytes: number): string {
    return this._formatFileSize(bytes);
  }

  public removeFile(): void {
    this.showFileLoad = null;
    this.hasError = false;
    this.errorMessage = '';
    this.fileToUpload.emit(null);
  }
}
